import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

const initialState = {
    showProductListDesktop: 1,
    showProductListMobile: 1,
    desktopPlaylist: 1,
    mobilePlaylist: 1,
    playlistTitle: 'Shoppable Video',
    live_playlist_title: 'Live Streaming',
    recorded_playlist_title: 'Recorded',
    upcoming_playlist_title: 'Upcoming',
    videobgColor: '#000',
    CartButtonText: 'Add To Cart',
    SoldOutText: 'Sold Out',
    CartButtonColor: '#6B7280',
    error: '',
    status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
    validationErrors: {}
}

export const fetchStoreConfig = createAsyncThunk(
    'store_info/fetchStoreConfig', async (customFetch, { rejectWithValue, getState }) => {
        try {
            const response = await customFetch('/api/store-data', { method: 'GET' })
            let res_data = await response.json()
            console.log(res_data)
            if (res_data.status == 1) {
                return res_data.data
            } else {
                return rejectWithValue(res_data.data)
            }
        } catch (err) {
            return rejectWithValue(err.toString())
        }
    }
)

export const submitStoreConfig = createAsyncThunk(
    'store_info/submitStoreConfig', async (customFetch, { rejectWithValue, getState }) => {
        const storeInfo = getState().storeInfo
        console.log('storeInfo validateionErrors ', storeInfo.validationErrors)
        if(Object.keys(storeInfo.validationErrors).length > 0) {
            return rejectWithValue(Object.values(storeInfo.validationErrors)[0])
        }
        let options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                desktop: { playlist: storeInfo.desktopPlaylist, showProductListDesktop: storeInfo.showProductListDesktop },
                mobile: { playlist: storeInfo.mobilePlaylist, showProductListMobile: storeInfo.showProductListMobile },
                playlistTitle: storeInfo.playlistTitle,
                live_playlist_title: storeInfo.live_playlist_title,
                recorded_playlist_title: storeInfo.recorded_playlist_title,
                upcoming_playlist_title: storeInfo.upcoming_playlist_title,
                videoBgColor: storeInfo.videobgColor,
                AddToCartText: storeInfo.CartButtonText,
                SoldOutTextBtn: storeInfo.SoldOutText,
                AddToCartColor: storeInfo.CartButtonColor
            })
        }
        try {
            const response = await customFetch('/api/store-data', options)
            let res_data = await response.json()
            if (res_data.status == 1) {
                return res_data.data
            } else {
                rejectWithValue(res_data.data)
            }
        } catch (err) {
            rejectWithValue(err.toString())
        }
    }
)

export const storeSlice = createSlice({
    name: 'store_info',
    initialState,
    reducers: {
        setStoreInfo: (state, action) => {
            const { payload } = action
            return {
                ...state,
                desktopPlaylist: payload?.desktopPlaylist || state.desktopPlaylist,
                mobilePlaylist: payload?.mobilePlaylist || state.mobilePlaylist,
                showProductListDesktop: payload?.showProductListDesktop || state.showProductListDesktop,
                showProductListMobile: payload?.showProductListMobile || state.showProductListMobile,
                playlistTitle: payload.hasOwnProperty('playlistTitle') ? payload.playlistTitle : state.playlistTitle,
                live_playlist_title: payload.hasOwnProperty('live_playlist_title') ? payload.live_playlist_title : state.live_playlist_title,
                recorded_playlist_title: payload.hasOwnProperty('recorded_playlist_title') ? payload.recorded_playlist_title : state.recorded_playlist_title,
                upcoming_playlist_title: payload.hasOwnProperty('upcoming_playlist_title') ? payload.upcoming_playlist_title : state.upcoming_playlist_title,
                videobgColor: payload?.videobgColor || state.videobgColor,
                CartButtonText: payload.hasOwnProperty('CartButtonText') ? payload.CartButtonText : state.CartButtonText,
                SoldOutText: payload.hasOwnProperty('SoldOutText') ? payload.SoldOutText : state.SoldOutText,
                CartButtonColor: payload?.CartButtonColor || state.CartButtonColor
            }
        },
        updateAndValidateStoreData: (state, action) => {
            let {name, value} = action.payload
            state[name] = value
            if(!value) {
                console.log('updateAndValidateStoreData ', name, value)
                state.validationErrors[name] = `${name} is required`;
                return;
            } else {
                delete state.validationErrors[name]
            }
        },

        resetStoreInfo: (state, action) => {
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStoreConfig.pending, (state, action) => {
                return { ...state, status: 'loading' }
            })
            .addCase(fetchStoreConfig.fulfilled, (state, action) => {
                if (action.payload) {
                    let { AddToCartColor, AddToCartText, SoldOutTextBtn, desktop, mobile, playlistTitle, live_playlist_title, recorded_playlist_title, upcoming_playlist_title, videoBgColor } = action.payload
                    return {
                        ...state,
                        desktopPlaylist: desktop?.playlist || 1,
                        mobilePlaylist: mobile?.playlist || 1,
                        showProductListDesktop: desktop?.showProductListDesktop || 1,
                        showProductListMobile: mobile?.showProductListMobile || 1,
                        playlistTitle: playlistTitle || 'Shoppable Video',
                        live_playlist_title: live_playlist_title || 'live_playlist_title',
                        recorded_playlist_title: recorded_playlist_title || 'recorded_playlist_title',
                        upcoming_playlist_title: upcoming_playlist_title || 'upcoming_playlist_title',
                        videobgColor: videoBgColor || '#000',
                        CartButtonText: AddToCartText || 'Add To Cart',
                        SoldOutText: SoldOutTextBtn || 'Sold Out',
                        CartButtonColor: AddToCartColor || '#6B7280',
                        error: '',
                        status: 'success'
                    }
                } else 
                    return {...state, status: 'success'}
            })
            .addCase(fetchStoreConfig.rejected, (state, action) => {
                return { ...state, error: action.payload, status: `failed,${action.payload}` }
            })
            .addCase(submitStoreConfig.pending, (state, action) => {
                return { ...state, status: 'loading' }
            })
            .addCase(submitStoreConfig.fulfilled, (state, action) => {
                state.status= `success,${action.payload}`
                state.validationErrors = {}
            })
            .addCase(submitStoreConfig.rejected, (state, action) => {
                return { ...state, error: action.payload, status: `failed,${action.payload}` }
            })
    }
})

export const { setStoreInfo, resetStoreInfo, updateAndValidateStoreData } = storeSlice.actions

export default storeSlice.reducer